import React, { useEffect, useContext, useCallback, useState } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Container } from './styles';

import { ComboBoxContext } from '../../../contexts/ComboBoxContext';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';

interface Empresa {
  cd: string;
  cd_empresa: string;
  nm: string;
}

const ComboBox = ({ ...rest }) => {
  const { cdEmpresa, setCdEmpresa, empresa, setEmpresa } = useContext(ComboBoxContext);
  const [emp, setEmp] = useState<Empresa[]>([])
  const [cdEmp, setCdEmp] = useState(0)
  const handleChange: any = (e: any) => {
    setCdEmpresa(e.target.value as number);
    setCdEmp(e.target.value as number);
    console.log(cdEmpresa)
    console.log(cdEmp)
  };
  const { addToast } = useToast();

  const populaTabela = useCallback(() => {
    api
      .get<Empresa[]>('empresas')
      .then((response) => {
        setEmpresa(response.data);
        setEmp(response.data);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu um erro ao listar as empresa: ${error}`,
        });
      });
  }, [setEmpresa, setEmp, addToast]);

  useEffect(() => {
    populaTabela();
  }, [populaTabela]);

  useEffect(() => {
    if (cdEmpresa || cdEmpresa == 0) {
      sessionStorage.setItem('cd', `${cdEmpresa}`);
    }
    if (sessionStorage.getItem('cd') && setCdEmpresa) {
      const CodigoEmpresa = sessionStorage.getItem('cd');
      setCdEmpresa(Number(CodigoEmpresa));
    }
  }, [setCdEmpresa, cdEmpresa]);

  useEffect(() => {
    if (cdEmp || cdEmp == 0) {
      sessionStorage.setItem('cd', `${cdEmp}`);
    }
    if (sessionStorage.getItem('cd') && setCdEmpresa) {
      const CodigoEmpresa = sessionStorage.getItem('cd');
      setCdEmpresa(Number(CodigoEmpresa));
    }
  }, [setCdEmpresa, cdEmp, cdEmpresa]);



  return (
    <Container {...rest}>
      <FormControl
        style={{
          width: '115px',
          borderRadius: '10px',
          height: '36px',
        }}
      >
        <InputLabel
          id="demo-simple-select-label"
          style={{
            margin: '-6px',
          }}
        />
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={cdEmpresa || cdEmp}
          onChange={handleChange}
          style={{
            height: '40px',
            width: '119px',
            color: '#2c73e9',
            fontWeight: 500,
          }}
          displayEmpty
        >
          <MenuItem value="0" defaultValue="Empresa" style={{ color: '#2c73e9', fontWeight: 500 }}>
            Empresas
          </MenuItem>
          {emp.map((empi: any) => (
            <MenuItem key={empi.cd} value={empi.cd_empresa}>
              {empi.nm}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Container>
  );
};

export default ComboBox;
